










































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {DxButton, DxScrollView, DxTextBox, DxTooltip, DxLoadIndicator} from 'devextreme-vue';
import DxTabPanel from 'devextreme-vue/tab-panel';
import {CellPreparedEvent} from 'devextreme/ui/data_grid';
import {Workbook} from 'exceljs';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {setAlternatingRowsBackground} from '@/utils/excel';

import TableGrid from '@/components/TableGrid/grid.vue';
import DButton from '@/components/DButton/button.vue';
import TransportHeaderSet from '@/components/HeaderSet/TransportHeaderSet.vue';

import BalanceService, {Grouping, totalCaptionObject} from '@/services/balance-service';
import DictsCacheService from "@/services/dicts_cache_service";
import EcoObjectsService from '@/services/eco-objects-service';
import {saveAs} from 'file-saver';
import getGridInstance from "@/utils/grid-instance";
import {FilialNodeItem} from '@/services/models-service';
import BalanceHeaderSet from '@/components/HeaderSet/BalanceHeaderSet.vue';
import { aggregate_periods } from '@/constants';

interface ScrollState {
  isScrolling: boolean;
  lastScrollLeft: number;
  lastScrollTop: number;
}

@Component({
  name: 'BalanceMain',
  components: {
    DxTabPanel,
    DxLoadIndicator,
    DxButton,
    DxTextBox,
    DxTooltip,
    TableGrid,
    DxScrollView,
    DButton,
    TransportHeaderSet,
    BalanceHeaderSet
  }
})

export default class extends Vue {
  public selectedTabIndex: number = 0;
  private selectedTabKey: string = 'main';

  private flattenData: any[] = [];
  private flattenDataCompare: any[] = [];
  private flattenDataDeviations: any[] = [];

  private service = BalanceService;

  private columnsMain: any[] = [];
  private columnsCompare: any[] = [];
  private columnsDeviations: any[] = [];
  private summary: any = {};

  private currentGrouping = Grouping.BY_PERIOD;

  public ecoService = EcoObjectsService;

  public showPlug: boolean = true;
  public filtersSelected: boolean = false;

  // Общий флаг загрузки данных
  public isLoadingData: boolean = false;

  public currentImbalanceValue = '0,00000';

  public isLoad: boolean = false;
  public current_cut: any = null;
  public current_filial: number | null = null;
  public current_node: number | null = null;
  public current_facility: number | null = null;
  public all_filials: any[] = [];
  public all_filials_tree: any = {};
  public all_facilities: any[] = [];

  private precisionValue = 3;

  public transformedDataGrid: any = null;
  public transformedDataGridCompare: any = null;
  public transformedDataGridDeviations: any = null;

  private cutNames = {
    name: "",
    secondary: ""
  }

  public selectedObjects: string[] = [""];
  public selectedGroupedObject: string[] = [];

  public on_display_internal_revolutions: boolean = false;

  private scrollState: ScrollState = {
    isScrolling: false,
    lastScrollLeft: 0,
    lastScrollTop: 0
  };
  private scrollHandlers: Array<() => void> = [];
  private scrollTimeout: any = null;
  private rafId: number | null = null;
  private scrollThrottleDelay: number = 10;

  private readyCtr = 0;
  private widgetCount = 1;
  private scrollSyncEnabled: boolean = false;
  private dataProcessingComplete: boolean = false;

  public selectionReal: any = {};

  get tabs() {
    const items: Array<{ key: string; title: string; header: string; disabled?: boolean }> = [];

    items.push({
      key: 'main',
      title: (this.cutNames?.name) || 'Основная срезка',
      header: (this.cutNames?.name) || ''
    });

    if (this.showCompareCut) {
      items.push({
        key: 'compare',
        title: (this.cutNames?.secondary) || 'Сравнение',
        header: (this.cutNames?.secondary) || ''
      });

      if (this.service.current.show_deviation && this.transformedDataGridDeviations) {
        items.push({
          key: 'deviations',
          title: 'Отклонения',
          header: 'Отклонения'
        });
      }
    }

    return items;
  }

  onSelectionRealChanged(selection: any) {
    this.selectionReal = selection;
  }

  @Watch('tabs')
  onTabsChanged(newTabs: Array<{ key: string; disabled?: boolean }>, oldTabs: Array<{ key: string; disabled?: boolean }>) {
    let idx = newTabs.findIndex(t => t.key === this.selectedTabKey);
    if (idx === -1) {
      this.selectedTabKey = 'main';
      idx = newTabs.findIndex(t => t.key === 'main');
    }

    if (newTabs[idx]?.disabled) {
      idx = newTabs.findIndex(t => !t.disabled);
      this.selectedTabKey = newTabs[Math.max(0, idx)]?.key || 'main';
    }

    this.selectedTabIndex = Math.max(0, idx);
  }

  onDisplayInternalRevolutions(data: boolean) {
    this.on_display_internal_revolutions = data
  }

  onSelectedObjectsChanged(selected: string[]) {
    this.selectedObjects = selected;
  }

  onSelectedGroupedObjectChanged(selected: string[]) {
    this.selectedGroupedObject = selected;
  }

  async getFilialsTree() {
    if (!this.current_cut) {
      return;
    }

    this.all_filials = [];
    this.all_filials_tree = {};
  }

  saveFilters() {
    // Implementation for saving filters
  }

  async mounted() {
    this.initColumns();
  }

  beforeDestroy() {
    this.cleanupScrollHandlers();
    this.cancelScrollTimeout();
    this.cancelRafId();
  }

  get showCompareCut() {
    return this.service.current.show_compare_cut && this.service.current.id_compare_cut
  }

  get balanceGrid() {
    if (this.service.current.id_cut) {
      return getGridInstance(this.$refs.balanceGrid);
    }
  }

  get balanceCompareGrid() {
    if (this.showCompareCut) {
      return getGridInstance(this.$refs.balanceCompareGrid);
    }
  }

  get balanceDeviationsGrid() {
    if (this.showCompareCut && this.service.current.show_deviation) {
      return getGridInstance(this.$refs.balanceDeviationsGrid);
    }
  }

  get nodes_ds() {
    if (!Object.keys(this.ecoService.filialNodesTree).length) {
      return [];
    }
    let result: any[] = [];
    for (const value of Object.values(this.ecoService.filialNodesTree)) {
      for (const nodeObj of Object.values<FilialNodeItem>(value)) {
        result.push({id: nodeObj.id, name: nodeObj.name, weight: '2'})
      }
    }
    return result;
  }

  @Watch('flattenData')
  onFlattenDataChanged() {
    this.transformedDataGrid = [...this.flattenData];
    this.checkAndCalculateDeviations();
  }

  @Watch('flattenDataCompare')
  onFlattenDataCompareChanged() {
    this.transformedDataGridCompare = [...this.flattenDataCompare];
    this.checkAndCalculateDeviations();
  }

  private checkAndCalculateDeviations() {
    if (this.flattenData.length > 0 && this.flattenDataCompare.length > 0 && this.dataProcessingComplete && this.service.current.show_deviation) {
      this.calculateDeviations();
    }
  }

  private calculateDeviations() {
    const deviations: any[] = [];
    
    const createRowKey = (row: any) => {
      const key = `${row.node_id}_${row.month}_${row.id_eco_facility || ''}`;
      return key;
    };

    const compareMap = new Map();
    this.flattenDataCompare.forEach(row => {
      compareMap.set(createRowKey(row), row);
    });

    this.flattenData.forEach(mainRow => {
      const key = createRowKey(mainRow);
      const compareRow = compareMap.get(key);

      if (compareRow) {
        const deviationRow = {
          id_eco_facility: mainRow.id_eco_facility,
          id_eco_heat_node: mainRow.id_eco_heat_node,
          month: mainRow.month,
          facility_name: mainRow.facility_name,
          node_id: mainRow.node_id,
          node_name: mainRow.node_name,
          is_total_node: mainRow.is_total_node,
          is_grouped_object: mainRow.is_grouped_object,
          is_aggregated_period: mainRow.is_aggregated_period,
          is_node_total: mainRow.is_node_total,
          display_order: mainRow.display_order,
          
          water: this.calculateWaterDeviation(mainRow.water, compareRow.water),
          steam: this.calculateSteamDeviation(mainRow.steam, compareRow.steam),
          total: this.calculateTotalDeviation(mainRow.total, compareRow.total),
        };

        deviations.push(deviationRow);
      }
    });

    this.flattenDataDeviations = deviations;
    this.transformedDataGridDeviations = [...deviations];
  }

  private calculateWaterDeviation(mainWater: any, compareWater: any): any {
    const deviation: any = {};
    
    const fields = [
      'sale_end_user_k',
      'sale_end_user_p',
      'gvs',
      'sale_vno_vgo',
      'sale_wo_volume',
      'sale_cost_delta',
      'purchase_vendor',
      'purchase_vno_vgo',
      'purchase_cost_delta'
    ];

    fields.forEach(field => {
      const main = parseFloat(mainWater?.[field] || 0);
      const compare = parseFloat(compareWater?.[field] || 0);
      deviation[field] = (main - compare).toFixed(3);
    });
    
    return deviation;
  }

  private calculateSteamDeviation(mainSteam: any, compareSteam: any): any {
    const deviation: any = {};
    
    const fields = [
      'sale_end_user_k',
      'sale_end_user_p',
      'gvs',
      'sale_vno_vgo',
      'sale_wo_volume',
      'sale_cost_delta',
      'purchase_vendor',
      'purchase_vno_vgo',
      'purchase_cost_delta'
    ];

    fields.forEach(field => {
      const main = parseFloat(mainSteam?.[field] || 0);
      const compare = parseFloat(compareSteam?.[field] || 0);
      deviation[field] = (main - compare).toFixed(3);
    });

    return deviation;
  }

  private calculateTotalDeviation(mainTotal: any, compareTotal: any): string {
    const main = parseFloat(mainTotal || 0);
    const compare = parseFloat(compareTotal || 0);
    return (main - compare).toFixed(2);
  }

  empty() {}

  onContentReady() {
    if (this.readyCtr < this.widgetCount) {
      this.readyCtr++;
    }
    if (this.readyCtr === this.widgetCount) {
      setTimeout(() => this.initScrollSync(), 200);
    }
  }

  private initScrollSync() {
    this.cleanupScrollHandlers();
    
    const grids: Array<{ instance: any; scrollable: any; name: string }> = [];
    
    if (this.balanceGrid) {
      const mainScrollable = this.balanceGrid.getScrollable?.();
      if (mainScrollable) {
        grids.push({ instance: this.balanceGrid, scrollable: mainScrollable, name: 'main' });
      }
    }

    if (this.balanceCompareGrid) {
      const compareScrollable = this.balanceCompareGrid.getScrollable?.();
      if (compareScrollable) {
        grids.push({ instance: this.balanceCompareGrid, scrollable: compareScrollable, name: 'compare' });
      }
    }

    if (this.balanceDeviationsGrid) {
      const deviationsScrollable = this.balanceDeviationsGrid.getScrollable?.();
      if (deviationsScrollable) {
        grids.push({ instance: this.balanceDeviationsGrid, scrollable: deviationsScrollable, name: 'deviations' });
      }
    }

    if (grids.length < 2) {
      this.scrollSyncEnabled = false;
      return;
    }

    const createScrollHandler = (sourceIndex: number) => {
      return (e: any) => {
        if (this.scrollState.isScrolling) {
          return;
        }

        const scrollLeft = e.scrollOffset?.left ?? e.scrollOffset?.x ?? 0;
        const scrollTop = e.scrollOffset?.top ?? e.scrollOffset?.y ?? 0;

        if (
          scrollLeft === this.scrollState.lastScrollLeft &&
          scrollTop === this.scrollState.lastScrollTop
        ) {
          return;
        }

        this.scrollState.lastScrollLeft = scrollLeft;
        this.scrollState.lastScrollTop = scrollTop;

        this.cancelScrollTimeout();
        this.cancelRafId();

        this.rafId = window.requestAnimationFrame(() => {
          this.rafId = null;
          this.scrollState.isScrolling = true;

          grids.forEach((grid, targetIndex) => {
            if (targetIndex !== sourceIndex && grid.scrollable) {
              try {
                const offset = {
                  left: scrollLeft,
                  top: scrollTop,
                  x: scrollLeft,
                  y: scrollTop
                };
                grid.scrollable.scrollTo(offset);
              } catch (err) {
                console.warn(`Ошибка синхронизации скролла ${grids[sourceIndex].name} -> ${grid.name}:`, err);
              }
            }
          });

          this.scrollTimeout = setTimeout(() => {
            this.scrollState.isScrolling = false;
            this.scrollTimeout = null;
          }, this.scrollThrottleDelay);
        });
      };
    };

    grids.forEach((grid, index) => {
      try {
        const handler = createScrollHandler(index);
        grid.scrollable.on("scroll", handler);
        this.scrollHandlers.push(() => {
          try {
            grid.scrollable.off("scroll", handler);
          } catch (err) {
            console.warn(`Ошибка удаления обработчика скролла ${grid.name}:`, err);
          }
        });
      } catch (err) {
        console.warn(`Ошибка регистрации обработчика скролла ${grid.name}:`, err);
      }
    });

    this.scrollSyncEnabled = true;
  }

  private cleanupScrollHandlers() {
    this.scrollHandlers.forEach(cleanup => {
      try {
        cleanup();
      } catch (err) {
        console.warn('Ошибка при очистке обработчика скролла:', err);
      }
    });
    this.scrollHandlers = [];
    this.scrollSyncEnabled = false;
    this.scrollState.isScrolling = false;
  }

  private cancelScrollTimeout() {
    if (this.scrollTimeout !== null) {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = null;
    }
  }

  private cancelRafId() {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  private getFilialName(filialId: number): string {
    const tree = this.ecoService.filialNodesFacilitiesTree;
    if (!tree || !tree[filialId]) {
      return 'Неизвестный филиал';
    }
    return tree[filialId].name || 'Неизвестный филиал';
  }

  private getNodeName(nodeId: number): string {
    const node = this.nodes_ds.find(n => n.id === nodeId);
    return node?.name || 'Неизвестный узел';
  }

  private getFacilityName(facilityId: number, input: any[]): string {
    if (!input || input.length === 0) {
      return 'Неизвестный объект';
    }

    for (const monthData of input) {
      if (!monthData.nodes || !Array.isArray(monthData.nodes)) {
        continue;
      }

      for (const node of monthData.nodes) {
        if (!node.facilities || !Array.isArray(node.facilities)) {
          continue;
        }

        const facility = node.facilities.find((f: any) => f.facility_id === facilityId);
        if (facility) {
          return facility.name || 'Неизвестный объект';
        }
      }
    }

    return 'Неизвестный объект';
  }

  private getFilialIdByNode(nodeId: number | string | null): number | null {
    if (nodeId === null || nodeId === undefined) return null;
    const tree = this.ecoService.filialNodesFacilitiesTree || {};

    for (const [filialId, filial] of Object.entries<any>(tree)) {
      const nodes = filial?.nodes || filial?.heat_nodes || {};
      if (Array.isArray(nodes)) {
        if (nodes.includes(nodeId) || nodes.includes(Number(nodeId))) {
          return Number(filialId);
        }
      } else if (typeof nodes === 'object' && nodes !== null) {
        if (nodes[nodeId] || nodes[Number(nodeId)]) {
          return Number(filialId);
        }
      }
    }

    return null;
  }

  async flattenTransportDataSorted(idCut: string | null) {
    const { id_eco_heat_nodes, period, show_selected_nodes_facility } = this.service.current;


    const input = await this.service.getCoastBalanceWithFilter(idCut, id_eco_heat_nodes, period);

    const monthOrder = new Map<string, number>();
    input.forEach((m: any, idx: number) => {
      const key = String(m?.month ?? '').toLowerCase();
      if (!monthOrder.has(key)) {
        monthOrder.set(key, idx);
      }
    });

    const num = (v: any): number => {
      if (v === null || v === undefined) return 0;
      if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
      const s = String(v).replace(/\s/g, '').replace(',', '.');
      const n = parseFloat(s);
      return Number.isFinite(n) ? n : 0;
    };

    const selectedFilials = new Set<number>(this.selectionReal?.filials || []);
    const selectedNodes = new Set<number>(this.selectionReal?.nodes || []);
    const selectedFacilities = new Set<number>(this.selectionReal?.facilities || []);

    const filialTotals: Record<string, any> = {};
    const nodeTotals: Record<string, any> = {};
    const result: any[] = [];

    // Обрабатываем индивидуальные выборы (если они есть)
    // ПАО ТПлюс обрабатывается отдельно ниже
    for (const monthEntry of input) {
      const month = monthEntry?.month ?? null;
      const nodes = Array.isArray(monthEntry?.nodes) ? monthEntry.nodes : [];

      for (const node of nodes) {
        const nodeId = node?.node_id ?? null;
        const nodeName = this.getNodeName(Number(nodeId));
        const filialId = this.getFilialIdByNode(nodeId);
        const facilities = Array.isArray(node?.facilities) ? node.facilities : [];

        // 1. Объекты (только выбранные)
        for (const f of facilities) {
            const facilityId = f?.facility_id ?? null;
            if (!selectedFacilities.has(Number(facilityId))) continue;

            const nameRaw = this.getFacilityName(Number(facilityId), input) ?? f?.name ?? null;
            const facilityDisplay = nameRaw ? `Объект: ${nameRaw}` : 'Объект';

            const wSales = num(f?.water?.sale_end_user_k) + num(f?.water?.sale_end_user_p) +
                          num(f?.water?.gvs) + num(f?.water?.sale_vno_vgo) + num(f?.water?.sale_wo_volume);
            const wPurch = num(f?.water?.purchase_vendor) + num(f?.water?.purchase_vno_vgo);
            const sSales = num(f?.steam?.sale_end_user_k) + num(f?.steam?.sale_end_user_p) +
                          num(f?.steam?.gvs) + num(f?.steam?.sale_vno_vgo) + num(f?.steam?.sale_wo_volume);
            const sPurch = num(f?.steam?.purchase_vendor) + num(f?.steam?.purchase_vno_vgo);
            const total = (wSales - wPurch) + (sSales - sPurch);

            result.push({
              id_eco_facility: facilityId,
              id_eco_heat_node: nodeId,
              month,
              facility_name: facilityDisplay,
              node_id: nodeId,
              node_name: nodeName,
              water: f?.water,
              steam: f?.steam,
              total: total.toFixed(2),
              display_order: 4
            });
          }

        // 2. Узлы
        if (selectedNodes.has(Number(nodeId))) {
          const key = `${nodeId}|${month}`;
          if (!nodeTotals[key]) {
            nodeTotals[key] = {
              id_eco_heat_node: nodeId,
              node_id: nodeId,
              node_name: nodeName,
              facility_name: `ТУ: ${nodeName}`,
              month,
              water: {},
              steam: {},
              total: 0,
              display_order: 3
            };
          }

          const target = nodeTotals[key];
          for (const f of facilities) {
            for (const section of ['water', 'steam'] as const) {
              if (f[section]) {
                for (const [k, v] of Object.entries(f[section])) {
                  target[section][k] = (target[section][k] || 0) + (parseFloat(v as any) || 0);
                }
              }
            }

            const wSales = num(f?.water?.sale_end_user_k) + num(f?.water?.sale_end_user_p) +
                          num(f?.water?.gvs) + num(f?.water?.sale_vno_vgo) + num(f?.water?.sale_wo_volume);
            const wPurch = num(f?.water?.purchase_vendor) + num(f?.water?.purchase_vno_vgo);
            const sSales = num(f?.steam?.sale_end_user_k) + num(f?.steam?.sale_end_user_p) +
                          num(f?.steam?.gvs) + num(f?.steam?.sale_vno_vgo) + num(f?.steam?.sale_wo_volume);
            const sPurch = num(f?.steam?.purchase_vendor) + num(f?.steam?.purchase_vno_vgo);
            target.total += (wSales - wPurch) + (sSales - sPurch);
          }
        }

        // 3. Филиалы
        if (filialId !== null && selectedFilials.has(Number(filialId))) {
          const key = `${filialId}|${month}`;
          if (!filialTotals[key]) {
            filialTotals[key] = {
              id_eco_heat_node: `filial_${filialId}`,
              node_id: `filial_${filialId}`,
              node_name: this.getFilialName(Number(filialId)),
              facility_name: `Филиал: ${this.getFilialName(Number(filialId))}`,
              month,
              water: {},
              steam: {},
              total: 0,
              display_order: 2
            };
          }

          const target = filialTotals[key];
          for (const f of facilities) {
            for (const section of ['water', 'steam'] as const) {
              if (f[section]) {
                for (const [k, v] of Object.entries(f[section])) {
                  target[section][k] = (target[section][k] || 0) + (parseFloat(v as any) || 0);
                }
              }
            }

            const wSales = num(f?.water?.sale_end_user_k) + num(f?.water?.sale_end_user_p) +
                          num(f?.water?.gvs) + num(f?.water?.sale_vno_vgo) + num(f?.water?.sale_wo_volume);
            const wPurch = num(f?.water?.purchase_vendor) + num(f?.water?.purchase_vno_vgo);
            const sSales = num(f?.steam?.sale_end_user_k) + num(f?.steam?.sale_end_user_p) +
                          num(f?.steam?.gvs) + num(f?.steam?.sale_vno_vgo) + num(f?.steam?.sale_wo_volume);
            const sPurch = num(f?.steam?.purchase_vendor) + num(f?.steam?.purchase_vno_vgo);
            target.total += (wSales - wPurch) + (sSales - sPurch);
          }
        }
      }
    }

    // Добавляем агрегаты узлов
    for (const total of Object.values<any>(nodeTotals)) {
      result.push({
        ...total,
        total: total.total.toFixed(2)
      });
    }

    // Добавляем агрегаты филиалов
    for (const total of Object.values<any>(filialTotals)) {
      result.push({
        ...total,
        total: total.total.toFixed(2)
      });
    }

    // 4. Обрабатываем ПАО ТПлюс (если выбран)
    if (this.selectionReal?.t_plus === true) {
      // Агрегируем данные по ВСЕМ объектам из input
      const paoTplusTotals: Record<string, any> = {};
      
      for (const monthEntry of input) {
        const month = monthEntry?.month ?? null;
        const nodes = Array.isArray(monthEntry?.nodes) ? monthEntry.nodes : [];
        
        const key = `pao_tplus|${month}`;
        if (!paoTplusTotals[key]) {
          paoTplusTotals[key] = {
            id_eco_heat_node: null,
            node_id: null,
            node_name: null,
            facility_name: 'ПАО "Т Плюс"',
            month,
            water: {},
            steam: {},
            total: 0,
            display_order: 1
          };
        }
        
        const target = paoTplusTotals[key];
        for (const node of nodes) {
          const facilities = Array.isArray(node?.facilities) ? node.facilities : [];
          for (const f of facilities) {
            for (const section of ['water', 'steam'] as const) {
              if (f[section]) {
                for (const [k, v] of Object.entries(f[section])) {
                  target[section][k] = (target[section][k] || 0) + (parseFloat(v as any) || 0);
                }
              }
            }
            
            const wSales = num(f?.water?.sale_end_user_k) + num(f?.water?.sale_end_user_p) +
                          num(f?.water?.gvs) + num(f?.water?.sale_vno_vgo) + num(f?.water?.sale_wo_volume);
            const wPurch = num(f?.water?.purchase_vendor) + num(f?.water?.purchase_vno_vgo);
            const sSales = num(f?.steam?.sale_end_user_k) + num(f?.steam?.sale_end_user_p) +
                          num(f?.steam?.gvs) + num(f?.steam?.sale_vno_vgo) + num(f?.steam?.sale_wo_volume);
            const sPurch = num(f?.steam?.purchase_vendor) + num(f?.steam?.purchase_vno_vgo);
            target.total += (wSales - wPurch) + (sSales - sPurch);
          }
        }
      }
      
      // Добавляем агрегаты ПАО ТПлюс
      for (const total of Object.values<any>(paoTplusTotals)) {
        result.push({
          ...total,
          total: total.total.toFixed(2)
        });
      }
    }

    result.sort((a, b) => {
      const orderA = a.display_order ?? 999;
      const orderB = b.display_order ?? 999;
      if (orderA !== orderB) return orderA - orderB;

      const nameA = (a.node_name || a.facility_name || '').toString();
      const nameB = (b.node_name || b.facility_name || '').toString();
      const byName = nameA.localeCompare(nameB, ['ru', 'en'], { sensitivity: 'accent', numeric: true });
      if (byName !== 0) return byName;

      const idxA = monthOrder.get(String(a.month ?? '').toLowerCase());
      const idxB = monthOrder.get(String(b.month ?? '').toLowerCase());
      const ai = idxA === undefined ? Number.POSITIVE_INFINITY : idxA;
      const bi = idxB === undefined ? Number.POSITIVE_INFINITY : idxB;
      return ai - bi;
    });

    return this.addAggregatedPeriodRows(result);
  }

  private periodOrder: Record<string, number> = {
    january: 1, february: 2, march: 3, april: 4, may: 5, june: 6,
    july: 7, august: 8, september: 9, october: 10, november: 11, december: 12,
    a_month: 13, wane_a_month: 14, two_months: 15, wane_two_months: 16,
    three_months: 17, wane_three_months: 18, first_quarter: 19, four_months: 20,
    wane_four_months: 21, five_months: 22, wane_five_months: 23, six_months: 24,
    wane_six_months: 25, second_quarter: 26, first_half: 27, seven_months: 28,
    wane_seven_months: 29, eight_months: 30, wane_eight_months: 31, nine_months: 32,
    wane_nine_months: 33, third_quarter: 34, ten_months: 35, wane_ten_months: 36,
    eleven_months: 37, wane_eleven_months: 38, twelve_months: 39, wane_twelve_months: 40,
    thourth_quarter: 41, second_half: 42, year: 43
  };

  private addAggregatedPeriodRows(flatData: any[]): any[] {
    const selectedPeriods = this.service.current.period || [];

    const monthNames = ['january', 'february', 'march', 'april', 'may', 'june',
                        'july', 'august', 'september', 'october', 'november', 'december'];

    const aggregatedPeriods = selectedPeriods.filter((p: string) =>
      !monthNames.includes(p) && aggregate_periods[p]
    );

    if (aggregatedPeriods.length === 0) {
      return flatData;
    }

    const result: any[] = [];
    const showFacilities = this.service.current.show_selected_nodes_facility;

    const grouped: Record<string, any[]> = {};
    flatData.forEach(row => {
      let key: string;
      if (row.is_total_node) {
        key = `total_node`;
      } else if (row.is_grouped_object) {
        key = `grouped_${row.id_eco_facility}`;
      } else if (row.is_node_total) {
        key = `node_total_${row.node_id}`;
      } else {
        key = showFacilities ? `${row.node_id}|${row.id_eco_facility}` : `${row.node_id}`;
      }
      
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(row);
    });

    Object.entries(grouped).forEach(([key, rows]) => {
      result.push(...rows);

      const firstRow = rows[0];
      const nodeId = firstRow.node_id;
      const facilityId = firstRow.id_eco_facility;
      const facilityName = firstRow.facility_name;
      const nodeName = firstRow.node_name;
      const isTotalNode = firstRow.is_total_node;
      const isGroupedObject = firstRow.is_grouped_object;
      const isNodeTotal = firstRow.is_node_total;

      aggregatedPeriods.forEach((period: string) => {
        const monthsInPeriod = aggregate_periods[period];
        if (!monthsInPeriod) return;

        const periodRows = rows.filter(row => monthsInPeriod.includes(row.month?.toLowerCase()));
        if (periodRows.length === 0) return;

        const totalRow = this.createAggregatedRow(
          period,
          periodRows,
          nodeId,
          facilityId,
          facilityName,
          isTotalNode,
          nodeName,
          isGroupedObject,
          isNodeTotal
        );
        result.push(totalRow);
      });
    });

    return result;
  }

  private createAggregatedRow(
    period: string,
    monthlyRows: any[],
    nodeId?: number | null,
    facilityId?: number | null,
    facilityName?: string | null,
    isTotalNode?: boolean,
    nodeName?: string | null,
    isGroupedObject?: boolean,
    isNodeTotal?: boolean
  ): any {
    const waterSum: any = {};
    const steamSum: any = {};
    
    const waterFields = [
      'sale_end_user_k',
      'sale_end_user_p',
      'gvs',
      'sale_vno_vgo',
      'sale_wo_volume',
      'sale_cost_delta',
      'purchase_vendor',
      'purchase_vno_vgo',
      'purchase_cost_delta'
    ];

    waterFields.forEach(field => {
      waterSum[field] = monthlyRows.reduce((sum, row) => {
        const value = row?.water?.[field];
        return sum + parseFloat(value || 0);
      }, 0);
    });

    waterFields.forEach(field => {
      steamSum[field] = monthlyRows.reduce((sum, row) => {
        const value = row?.steam?.[field];
        return sum + parseFloat(value || 0);
      }, 0);
    });

    let total = 0;
      const num = (v: any): number => {
        if (v === null || v === undefined) return 0;
        if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
        const s = String(v).replace(/\s/g, '').replace(',', '.');
        const n = parseFloat(s);
        return Number.isFinite(n) ? n : 0;
      };

      const wSales = num(waterSum.sale_end_user_k) + num(waterSum.sale_end_user_p) + 
                    num(waterSum.gvs) + num(waterSum.sale_vno_vgo) + num(waterSum.sale_wo_volume);
      const wPurch = num(waterSum.purchase_vendor) + num(waterSum.purchase_vno_vgo);
      const sSales = num(steamSum.sale_end_user_k) + num(steamSum.sale_end_user_p) + 
                    num(steamSum.gvs) + num(steamSum.sale_vno_vgo) + num(steamSum.sale_wo_volume);
      const sPurch = num(steamSum.purchase_vendor) + num(steamSum.purchase_vno_vgo);
      total = (wSales - wPurch) + (sSales - sPurch);

    const result: any = {
      id_eco_facility: facilityId,
      id_eco_heat_node: nodeId,
      month: period,
      facility_name: facilityName,
      node_id: nodeId,
      node_name: nodeName,
      water: waterSum,
      steam: steamSum,
      total: total.toFixed(2),
      is_aggregated_period: true,
      is_total_node: isTotalNode || false,
      display_order: isTotalNode ? 1 : (isGroupedObject ? 2 : (isNodeTotal ? 3 : 4))
    };

    if (isGroupedObject) {
      result.is_grouped_object = true;
      result.display_order = 2;
    }

    if (isNodeTotal) {
      result.is_node_total = true;
      result.display_order = 3;
    }

    return result;
  }

  async flattenCoastGroupedDataSorted(idCut: string | null) {
    const { period } = this.service.current;

    if (this.selectedGroupedObject.length === 0) {
      return [];
    }

    let input: any[];
    input = await this.service.getCoastBalanceGroupedWithFilter(idCut, [], period, this.selectedGroupedObject);

    const monthOrder = new Map<string, number>();
    input.forEach((m: any, idx: number) => {
      const key = String(m?.month ?? '').toLowerCase();
      if (!monthOrder.has(key)) {
        monthOrder.set(key, idx);
      }
    });

    const num = (v: any): number => {
      if (v === null || v === undefined) return 0;
      if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
      const s = String(v).replace(/\s/g, '').replace(',', '.');
      const n = parseFloat(s);
      return Number.isFinite(n) ? n : 0;
    };

    const tempData: any[] = [];

    for (const monthEntry of input) {
      const month = monthEntry?.month ?? null;
      const nodes = Array.isArray(monthEntry?.g_objects) ? monthEntry.g_objects : [];

      for (const f of nodes) {
        let total = 0;

          const wSales =
            num(f?.water?.sale_end_user_k) +
            num(f?.water?.sale_end_user_p) +
            num(f?.water?.gvs) +
            num(f?.water?.sale_vno_vgo) +
            num(f?.water?.sale_wo_volume);

          const wPurch =
            num(f?.water?.purchase_vendor) +
            num(f?.water?.purchase_vno_vgo);

          const sSales =
            num(f?.steam?.sale_end_user_k) +
            num(f?.steam?.sale_end_user_p) +
            num(f?.steam?.gvs) +
            num(f?.steam?.sale_vno_vgo) +
            num(f?.steam?.sale_wo_volume);

          const sPurch =
            num(f?.steam?.purchase_vendor) +
            num(f?.steam?.purchase_vno_vgo);

          total = wSales - wPurch + sSales - sPurch;

        tempData.push({
          id_eco_facility: f?.id ?? null,
          id_eco_heat_node: null,
          month,
          node_name: f?.title ?? null,
          facility_name: f?.title ? `Групповой объект: ${f.title}` : 'Групповой объект',
          water: f?.water,
          steam: f?.steam,
          total: total.toFixed(2),
          is_grouped_object: true,
          display_order: 1
        });
      }
    }

    tempData.sort((a: any, b: any) => {
      const orderA = a.display_order ?? 999;
      const orderB = b.display_order ?? 999;
      if (orderA !== orderB) return orderA - orderB;

      const nameA = (a.node_name ?? '').toString();
      const nameB = (b.node_name ?? '').toString();

      const byName = nameA.localeCompare(nameB, ['ru', 'en'], {sensitivity: 'accent', numeric: true});
      if (byName !== 0) return byName;

      const idxA = monthOrder.get(String(a.month ?? '').toLowerCase());
      const idxB = monthOrder.get(String(b.month ?? '').toLowerCase());
      const ai = idxA === undefined ? Number.POSITIVE_INFINITY : idxA;
      const bi = idxB === undefined ? Number.POSITIVE_INFINITY : idxB;
      if (ai !== bi) return ai - bi;

      if ((a.id_eco_facility ?? 0) !== (b.id_eco_facility ?? 0)) {
        return (a.id_eco_facility ?? 0) - (b.id_eco_facility ?? 0);
      }

      return (a.id_eco_heat_node ?? 0) - (b.id_eco_heat_node ?? 0);
    });

    return this.addAggregatedPeriodRows(tempData);
  }

  private async mergeAndCalculateTotals(mainData: any[], mainGroupedData: any[]): Promise<any[]> {
    const mainObjectRows = mainData.filter(row => !row.is_total_node && !row.is_node_total);
    const groupedObjectRows = mainGroupedData.filter(row => !row.is_total_node);

    // Без добавления сводных строк: только реальные объекты и сгруппированные
    console.log("out", [...groupedObjectRows, ...mainObjectRows]);
    return [...groupedObjectRows, ...mainObjectRows];
  }

  async getLoad() {
    // Начинаем загрузку - устанавливаем флаг
    this.isLoadingData = true;

    this.cleanupScrollHandlers();
    this.cancelScrollTimeout();
    this.cancelRafId();
    
    this.flattenData = [];
    this.flattenDataCompare = [];
    this.flattenDataDeviations = [];
    this.transformedDataGrid = null;
    this.transformedDataGridCompare = null;
    this.transformedDataGridDeviations = null;
    this.scrollState.isScrolling = false;
    this.scrollState.lastScrollLeft = 0;
    this.scrollState.lastScrollTop = 0;
    this.dataProcessingComplete = false;
    
    this.readyCtr = 0;
    this.widgetCount = this.showCompareCut && this.service.current.show_deviation ? 3 : (this.showCompareCut ? 2 : 1);

    try {
      const mainData = await this.flattenTransportDataSorted(this.service.current.id_cut);
      const mainGroupedData = await this.flattenCoastGroupedDataSorted(this.service.current.id_cut);

      this.flattenData = await this.mergeAndCalculateTotals(mainData, mainGroupedData);

      if (this.showCompareCut) {
        const compareData = await this.flattenTransportDataSorted(this.service.current.id_compare_cut);
        const compareGroupedData = await this.flattenCoastGroupedDataSorted(this.service.current.id_compare_cut);
        this.flattenDataCompare = await this.mergeAndCalculateTotals(compareData, compareGroupedData);
      }

      this.dataProcessingComplete = true;
      this.checkAndCalculateDeviations();

      this.service.getWithFilter();
      this.initColumns();
    } catch (error) {
      console.error('Ошибка при загрузке данных:', error);
      // Продолжаем, даже если произошла ошибка
    } finally {
      this.isLoadingData = false;
    }
  }

  giveName(names: any) {
    this.cutNames = names;
  }

  listAnalysis(notEmpty: boolean) {
    this.showPlug = notEmpty;
  }

  analyzeFilterSelected(selected: boolean) {
    this.filtersSelected = selected
  }

  async exportBalance() {
    const workbook = new Workbook();

  // Основная таблица
  if (this.balanceGrid) {
    const wsMain = workbook.addWorksheet(this.cutNames.name || 'Main');
    await exportDataGrid({
      worksheet: wsMain,
      component: this.balanceGrid,
      topLeftCell: { row: 1, column: 1 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (!excelCell) return;
        if (this.service.current.grouping === Grouping.BY_PERIOD &&
            gridCell?.rowType === 'data' &&
            excelCell?.fullAddress.col === 1) {
          excelCell.font = { bold: true };
        }
        setAlternatingRowsBackground(gridCell, excelCell, 1);
      },
    });
  }

  // Таблица сравнения
  if (this.showCompareCut && this.balanceCompareGrid) {
    const wsCompare = workbook.addWorksheet(this.cutNames.secondary || 'Compare');
    await exportDataGrid({
      worksheet: wsCompare,
      component: this.balanceCompareGrid,
      topLeftCell: { row: 1, column: 1 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (!excelCell) return;
        setAlternatingRowsBackground(gridCell, excelCell, 1);
      },
    });
  }

  // Таблица отклонений (если используется)
  if (this.service.current.show_deviation && this.balanceDeviationsGrid) {
    const wsDev = workbook.addWorksheet('Отклонения');
    await exportDataGrid({
      worksheet: wsDev,
      component: this.balanceDeviationsGrid,
      topLeftCell: { row: 1, column: 1 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (!excelCell) return;
        setAlternatingRowsBackground(gridCell, excelCell, 1);
      },
    });
  }

  workbook.xlsx.writeBuffer().then((buffer) => {
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }),
      `Баланс_${this.cutNames.name}${this.showCompareCut ? '_' + this.cutNames.secondary : ''}.xlsx`);
  });
}


  private getCommonColumns(prefix: string): any[] {
    let data = [
      {
        dataField: `${prefix}.sale_end_user_k`,
        dataType: "number",
        format: "number",
        caption: "Продажа конечным потребителям с коллекторов",
        allowSorting: false,
      },
      {
        dataField: `${prefix}.sale_end_user_p`,
        dataType: "number",
        format: "number",
        caption: "Продажа конечным потребителям из теплосети",
        allowSorting: false,
      },
      {
        dataField: `${prefix}.gvs`,
        dataType: "number",
        format: "number",
        caption: "Тепловая энергия на нагрев ГВС",
        allowSorting: false,
      },
    ];

    if (this.on_display_internal_revolutions) {
      data.push({
        dataField: `${prefix}.sale_vno_vgo`,
        dataType: "number",
        format: "number",
        caption: "Продажа по внутренним оборотам (ВГО, ВНО, ВГО23)",
        allowSorting: false,
      })
    }

    data.push({
      dataField: `${prefix}.sale_wo_volume`,
      dataType: "number",
      format: "number",
      caption: "Реализация без учета объемов",
      allowSorting: false,
    })

    if(this.service.current.show_correlation){
      data.push({
        dataField:`${prefix}.sale_cost_delta`,
        dataType: "number",
        format: "number",
        caption: "Справочно: стоимостные корректировки (Реализация)",
        allowSorting: false,
      })
    }

    data.push({
      dataField: `${prefix}.purchase_vendor`,
      dataType: "number",
      format: "number",
      caption: "Покупка от сторонних поставщиков",
      allowSorting: false,
    })

    if (this.on_display_internal_revolutions) {
      data.push({
        dataField: `${prefix}.purchase_vno_vgo`,
        dataType: "number",
        format: "number",
        caption: "Покупка по внутренним оборотам (ВГО, ВНО, ВГО23)",
        allowSorting: false,
      })
    }

    if(this.service.current.show_correlation){
      data.push({
        dataField:`${prefix}.purchase_cost_delta`,
        dataType: "number",
        format: "number",
        caption: "Справочно: стоимостные корректировки (Покупка)",
        allowSorting: false,
      })
    }

    return data;
  }

  private initColumns() {
    const showFacilities = this.service.current.show_selected_nodes_facility;
    const grouping = this.service.current.grouping;

    const baseColumns: any[] = [];

    baseColumns.push({
      dataField: "month",
      dataType: "string",
      caption: "Период",
      width: 200,
      groupIndex: grouping === Grouping.BY_PERIOD ? 0 : null,
      lookup: {
        dataSource: DictsCacheService.periods,
        valueExpr: "name",
        displayExpr: "display",
      },
      sortOrder: "asc",
      allowSorting: true,
      calculateSortValue: (data: any) => {
        const value = String(data?.month ?? "").toLowerCase();
        return this.periodOrder[value] ?? Number.POSITIVE_INFINITY;
      },
      calculateGroupValue: (data: any) => {
        const value = String(data?.month ?? "").toLowerCase();
        const order = this.periodOrder[value] ?? Number.POSITIVE_INFINITY;
        return `${String(order).padStart(3, '0')}_${value}`;
      },
      customizeText: (cellInfo: any) => {
        const parts = cellInfo.valueText?.split('_') || [];
        if (parts.length > 1) {
          const periodName = parts.slice(1).join('_');
          const period = DictsCacheService.periods.find((p: any) => p.name?.toLowerCase() === periodName);
          return period?.display || cellInfo.valueText;
        }
        return cellInfo.valueText;
      }
    });

    if (!showFacilities) {
      baseColumns.push({
        dataField: "node_id",
        caption: "Тепловой узел",
        dataType: "string",
        groupIndex: grouping === Grouping.BY_PERIOD ? 1 : (grouping === Grouping.BY_FACILITY ? 0 : null),
        showInColumnChooser: false,
        sortOrder: 'asc',
        allowSorting: true,
        lookup: {
          dataSource: this.nodes_ds,
          valueExpr: "id",
          displayExpr: "name",
        },
        calculateGroupValue: (row: any) => {
          const order = row?.display_order ?? 999;
          const name = row?.node_name || '';
          return `${String(order).padStart(3, '0')}_${name}`;
        },
        sortingMethod: (a: any, b: any) => {
          const orderA = a?.display_order ?? 999;
          const orderB = b?.display_order ?? 999;
          if (orderA !== orderB) return orderA - orderB;
          const nameA = (a?.node_name || '').toLowerCase();
          const nameB = (b?.node_name || '').toLowerCase();
          return nameA.localeCompare(nameB, ['ru', 'en'], { sensitivity: 'accent', numeric: true });
        },
        calculateSortValue: (row: any) => {
          const order = row?.display_order ?? 999;
          const name = (row?.node_name || '').toLowerCase();
          return `${String(order).padStart(3, '0')}_${name}`;
        },
        calculateDisplayValue: (row: any) => {
          return this.getNodeName(Number(row.node_id)) || row.node_name;
        },
        groupCellTemplate: (cellElement: any, cellInfo: any) => {
          const displayValue = cellInfo.displayValue || cellInfo.value;
          const actualName = displayValue.includes('_') ? displayValue.split('_').slice(1).join('_') : displayValue;
          const node = this.nodes_ds.find(e => e.name === actualName);
          const isFilial = cellInfo.data.items?.[0]?.display_order === 1;
          const prefix = isFilial ? 'Филиал' : 'Тепловой узел';
          cellElement.innerText = `${prefix}: ${node?.name || actualName}`;
        },
      });
    }

    if (showFacilities) {
      baseColumns.push({
        dataField: "facility_name",
        dataType: "string",
        caption: "Объект",
        width: 270,
        groupIndex: grouping === Grouping.BY_PERIOD ? null : (grouping === Grouping.BY_FACILITY ? 0 : null),
        fixed: "left",
        sortOrder: "asc",
        allowSorting: true,
        sortingMethod: (a: any, b: any) => {
          const orderA = a?.display_order ?? 999;
          const orderB = b?.display_order ?? 999;
          if (orderA !== orderB) return orderA - orderB;
          const nameA = (a?.facility_name || a?.node_name || '').toLowerCase();
          const nameB = (b?.facility_name || b?.node_name || '').toLowerCase();
          return nameA.localeCompare(nameB, ['ru', 'en'], { sensitivity: 'accent', numeric: true });
        },
        calculateSortValue: (row: any) => {
          const order = row?.display_order ?? 999;
          const name = (row?.facility_name || row?.node_name || '').toLowerCase();
          return `${String(order).padStart(3, '0')}_${name}`;
        },
        calculateDisplayValue: (row: any) => {
          return row?.facility_name || row?.node_name || '';
        },
        groupCellTemplate: (cellElement: any, cellInfo: any) => {
          const first = cellInfo.data.items?.[0];
          const name = first?.facility_name || first?.node_name || cellInfo.value;
          cellElement.innerText = name;
        }
      });
    }

    baseColumns.push(
      {
        caption: "СЕТЕВАЯ ВОДА, тыс. руб.",
        columns: this.getCommonColumns("water"),
      },
      {
        caption: "ПАР, тыс. руб.",
        columns: this.getCommonColumns("steam"),
      }
    );

      baseColumns.push({
        dataField: "total",
        dataType: "number",
        format: "number",
        caption: "Прибыль (с учетом внутренних оборотов)",
        allowSorting: false,
      });
    

    this.columnsMain = [...baseColumns];
    this.columnsCompare = [...baseColumns];
    this.initColumnsDeviations();
  }

  private initColumnsDeviations() {
    const showFacilities = this.service.current.show_selected_nodes_facility;
    const grouping = this.service.current.grouping;

    const columnsLocal: any[] = [];

    columnsLocal.push({
      dataField: "month",
      dataType: "string",
      caption: "Период",
      width: 200,
      groupIndex: grouping === Grouping.BY_PERIOD ? 0 : null,
      lookup: {
        dataSource: DictsCacheService.periods,
        valueExpr: "name",
        displayExpr: "display",
      },
      sortOrder: "asc",
      allowSorting: true,
      calculateSortValue: (data: any) => {
        const value = String(data?.month ?? "").toLowerCase();
        return this.periodOrder[value] ?? Number.POSITIVE_INFINITY;
      },
      calculateGroupValue: (data: any) => {
        const value = String(data?.month ?? "").toLowerCase();
        const order = this.periodOrder[value] ?? Number.POSITIVE_INFINITY;
        return `${String(order).padStart(3, '0')}_${value}`;
      },
      customizeText: (cellInfo: any) => {
        const parts = cellInfo.valueText?.split('_') || [];
        if (parts.length > 1) {
          const periodName = parts.slice(1).join('_');
          const period = DictsCacheService.periods.find((p: any) => p.name?.toLowerCase() === periodName);
          return period?.display || cellInfo.valueText;
        }
        return cellInfo.valueText;
      }
    });

    // if (!showFacilities) {
    //   columnsLocal.push({
    //     dataField: "node_id",
    //     caption: "Тепловой узел",
    //     dataType: "string",
    //     groupIndex: grouping === Grouping.BY_PERIOD ? 1 : (grouping === Grouping.BY_FACILITY ? 0 : null),
    //     showInColumnChooser: false,
    //     sortOrder: "asc",
    //     allowSorting: true,
    //     lookup: {
    //       dataSource: this.nodes_ds,
    //       valueExpr: "id",
    //       displayExpr: "name",
    //     },
    //     calculateGroupValue: (row: any) => {
    //       const order = row?.display_order ?? 999;
    //       const name = row?.node_name || '';
    //       return `${String(order).padStart(3, '0')}_${name}`;
    //     },
    //     calculateDisplayValue: (row: any) => {
    //       return this.getNodeName(Number(row.node_id)) || row.node_name;
    //     },
    //     groupCellTemplate: (cellElement: any, cellInfo: any) => {
    //       const displayValue = cellInfo.displayValue || cellInfo.value;
    //       const actualName = displayValue.includes('_') ? displayValue.split('_').slice(1).join('_') : displayValue;
    //       const node = this.nodes_ds.find(e => e.name === actualName);
    //       const isFilial = cellInfo.data.items?.[0]?.display_order === 1;
    //       const prefix = isFilial ? 'Филиал' : 'Тепловой узел';
    //       cellElement.innerText = `${prefix}: ${node?.name || actualName}`;
    //     },
    //   });
    // }

    if (showFacilities) {
      columnsLocal.push({
        dataField: "facility_name",
        dataType: "string",
        caption: "Объект",
        width: 270,
        groupIndex: grouping === Grouping.BY_PERIOD ? 1 : (grouping === Grouping.BY_FACILITY ? 0 : null),
        fixed: "left",
        sortOrder: "asc",
        allowSorting: true,
        sortingMethod: (a: any, b: any) => {
          const orderA = a?.display_order ?? 999;
          const orderB = b?.display_order ?? 999;
          if (orderA !== orderB) return orderA - orderB;
          const nameA = (a?.facility_name || a?.node_name || '').toLowerCase();
          const nameB = (b?.facility_name || b?.node_name || '').toLowerCase();
          return nameA.localeCompare(nameB, ['ru', 'en'], { sensitivity: 'accent', numeric: true });
        },
        calculateSortValue: (row: any) => {
          const order = row?.display_order ?? 999;
          const name = (row?.facility_name || row?.node_name || '').toLowerCase();
          return `${String(order).padStart(3, '0')}_${name}`;
        },
        calculateDisplayValue: (row: any) => {
          return row?.facility_name || row?.node_name || '';
        },
        groupCellTemplate: (cellElement: any, cellInfo: any) => {
          const first = cellInfo.data.items?.[0];
          const name = first?.facility_name || first?.node_name || cellInfo.value;
          cellElement.innerText = name;
        }
      });
    }

    columnsLocal.push(
      {
        caption: "СЕТЕВАЯ ВОДА, тыс.Гкал (отклонение)",
        columns: this.getCommonColumns("water"),
      },
      {
        caption: "ПАР, тыс.Гкал (отклонение)",
        columns: this.getCommonColumns("steam"),
      }
    );

      columnsLocal.push({
        dataField: "total",
        dataType: "number",
        format: "number",
        caption: "Отклонение прибыли",
        allowSorting: false,
      });

    this.columnsDeviations = columnsLocal;
  }

  private customizeCell(e: CellPreparedEvent) {
    if (e.rowType === 'header') {
      e.cellElement.style.textAlign = 'center';

      const caption = e.column.caption || '';
      if (['СЕТЕВАЯ ВОДА, тыс.Гкал', 'ПАР, тыс.Гкал', 'СЕТЕВАЯ ВОДА, тыс.Гкал (отклонение)', 'ПАР, тыс.Гкал (отклонение)'].includes(caption)) {
        e.cellElement.style.backgroundColor =
          caption.includes('ПАР') ? '#dbdbdb' : '#b4c7e7';
      }

      if (!e.cellElement.querySelector('.dx-datagrid-text-content') && caption) {
        const div = document.createElement('div');
        div.className = 'dx-datagrid-text-content';
        div.textContent = caption;
        e.cellElement.innerHTML = '';
        e.cellElement.appendChild(div);
      }
      return;
    }
  }

  @Watch("current_cut")
  async changeCut() {
    if (!this.isLoad) return;
    const prevFilial: number | null = this.current_filial;
    const prevNode: number | null = this.current_node;
    const prevFacility: number | null = this.current_facility;
    if (this.current_cut) {
      await this.getFilialsTree();
      if (this.all_filials.some((f: any) => f.id === prevFilial)) {
        this.current_filial = prevFilial;
        if (this.all_filials_tree[`${prevFilial}`]?.some((n: any) => n.id === prevNode)) {
          this.current_node = prevNode;
          if (this.all_facilities?.some((f: any) => f.id === prevFacility)) {
            this.current_facility = prevFacility;
          } else {
            this.current_facility = null;
          }
        } else {
          this.current_node = null;
          this.current_facility = null;
        }
      } else {
        this.current_filial = null;
        this.current_node = null;
        this.current_facility = null;
      }
    } else {
      this.current_filial = null;
      this.current_node = null;
      this.current_facility = null;
    }
    this.saveFilters && this.saveFilters();
  }
}
